module.exports = __webpack_public_path__ + "InterstateWGL-Light.7e2e26aa7e0d3d142cd5.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/InterstateWGL-Light.woff2
// module id = ../../../../../src/assets/layout/fonts/InterstateWGL-Light.woff2
// module chunks = styles